import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";
import Honeycombs from "@areas/shared/components/background/Honeycombs";
import TextFilter from "@areas/shared/components/text/TextFilter";
import Pagination from "@areas/shared/components/paginations/Pagination";

import { metaActions } from "@store";

import JobMarketPageCards from "./JobMarketPageCards";
import {
  enrichPagesWithCompanies,
  fetchCareerCenterPages,
  filterPagesWithCompany,
} from "./jobMarketHelpers";
import styles from "./styles/jobMarket.module.css";

const ITEMS_PER_PAGE = 9;

function AllPages() {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    dispatch(
      metaActions.setData({
        icon: "/faviconSchoolboy.ico",
        title: "Рынок труда — все материалы",
        description:
          "Полный список материалов о рынке труда Республики Башкортостан",
      })
    );
  }, [dispatch]);

  const loadData = useCallback((offset) => {
    setLoad(true);
    fetchCareerCenterPages(offset, ITEMS_PER_PAGE)
      .then((res) => {
        const pages = filterPagesWithCompany(res?.data);

        return enrichPagesWithCompanies(pages).then((items) => ({
          items,
          total: res?.total || 0,
        }));
      })
      .then(({ items, total }) => {
        setItems(items);
        setTotal(total);
      })
      .catch(() => {
        setItems([]);
        setTotal(0);
      })
      .finally(() => setLoad(false));
  }, []);

  useEffect(() => {
    loadData((page - 1) * ITEMS_PER_PAGE);
  }, [page, loadData]);

  const handlePageChange = useCallback((offset) => {
    setPage(Math.floor(offset / ITEMS_PER_PAGE) + 1);
  }, []);

  return (
    <div className={styles.allPages}>
      <Animation
        animationIn={animationStyles.swipeLeftIn}
        animationOut={animationStyles.swipeRightOut}
      >
        <div className={styles.allPagesHero}>
          <Honeycombs style={styles.allPagesBackground} filter="#6E9A10" />
          <div className={`container ${styles.allPagesHeroContent}`}>
            <Link to="/fschool/rynok-truda" className={styles.backLink}>
              ← Рынок труда
            </Link>
            <TextFilter
              customStyles={{
                all: styles.pageTitle,
                text: styles.pageTitleText,
                filter: styles.pageTitleFilter,
              }}
            >
              Рынок труда
            </TextFilter>
            <p className={styles.subtitle}>Все материалы раздела</p>
          </div>
        </div>
      </Animation>

      <Animation>
        <div className={`container ${styles.allPagesContent}`}>
          {load ? (
            <div className={styles.newsLoader}>
              <ClipLoader color="#6E9A10" />
            </div>
          ) : (
            <>
              <JobMarketPageCards items={items} />
              <Pagination
                load={load}
                itemsPerPage={ITEMS_PER_PAGE}
                totalItems={total}
                onChangePage={handlePageChange}
              />
            </>
          )}
        </div>
      </Animation>
    </div>
  );
}

export default AllPages;
